import React, { useState } from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { Link, withRouter } from "react-router-dom";
import {
    CircularProgress,
    makeStyles,
    Button,
    TextField,
} from "@material-ui/core";
import { AdminSignup } from "../../actions/auth";
import Notify from "../customHelpers/Notify";
import Notification from "../customHelpers/Notification";
import logo from "../../assets/images/logo.png";

const useStyles = makeStyles((theme) => ({
    root: {
        height: "100vh",
        backgroundColor: "#f3f4f6",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    card: {
        maxWidth: 450,
        width: "100%",
        padding: theme.spacing(2),
        borderRadius: theme.spacing(1.5),
        boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    },
    logoContainer: {
        display: "flex",
        justifyContent: "center",
        marginBottom: theme.spacing(3),
    },
    logo: {
        maxHeight: 80,
    },
    title: {
        fontWeight: 600,
        color: "rgb(20,61,89)",
        textAlign: "center",
        marginBottom: theme.spacing(1),
    },
    subtitle: {
        textAlign: "center",
        color: "#6b7280",
        marginBottom: theme.spacing(4),
    },
    submitButton: {
        marginTop: theme.spacing(3),
        backgroundColor: "rgba(244,151,3,.8)",
        color: "#fff",
        fontWeight: 600,
        "&:hover": {
            backgroundColor: "rgba(244,151,3, 1)",
        },
    },
    links: {
        marginTop: theme.spacing(3),
        display: "flex",
        justifyContent: "center",
    },
    linkText: {
        color: "rgb(20,61,89)",
        textDecoration: "none",
        fontSize: "0.875rem",
        "&:hover": {
            textDecoration: "underline",
        },
    },
}));

const SignupComponent = ({ history }) => {
    const classes = useStyles();
    const { NotifyMessage, notify, setNotify } = Notify();
    const [values, setValues] = useState({
        name: "",
        email: "",
        password: "",
        error: "",
        loading: false,
        message: "",
        showForm: true,
    });

    const { name, email, password, error, loading, message, showForm } = values;

    const handleSubmit = (e) => {
        e.preventDefault();
        setValues({ ...values, loading: true, error: false });

        // Split name into first and last name for Staff model
        const nameParts = name.trim().split(" ");
        const firstName = nameParts[0];
        const lastName = nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";

        const user = { firstName, lastName, email, password };

        AdminSignup(user).then((data) => {
            if (data.err) {
                setValues({ ...values, error: data.err, loading: false });
                NotifyMessage({ message: data.err, type: "error" });
            } else {
                setValues({
                    ...values,
                    name: "",
                    email: "",
                    password: "",
                    error: "",
                    loading: false,
                    message: data.message || "Signup success! Please signin.",
                    showForm: false,
                });
                NotifyMessage({ message: data.message || "Signup success!", type: "success" });
            }
        });
    };

    const handleChange = (name) => (e) => {
        setValues({ ...values, error: false, [name]: e.target.value });
    };

    return (
        <div className={classes.root}>
            <Card className={classes.card}>
                <div className={classes.logoContainer}>
                    <img src={logo} className={classes.logo} alt="Logo" />
                </div>
                <CardContent>
                    <Typography variant="h5" className={classes.title}>
                        Create Account
                    </Typography>
                    <Typography variant="body2" className={classes.subtitle}>
                        Join Info Ethiopia Dashboard
                    </Typography>
                    {showForm ? (
                        <form onSubmit={handleSubmit}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                label="Full Name"
                                name="name"
                                value={name}
                                onChange={handleChange("name")}
                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                label="Email Address"
                                name="email"
                                autoComplete="email"
                                value={email}
                                onChange={handleChange("email")}
                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                label="Password"
                                name="password"
                                type="password"
                                value={password}
                                onChange={handleChange("password")}
                            />
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                className={classes.submitButton}
                                disabled={loading}
                            >
                                {loading ? <CircularProgress size={24} color="inherit" /> : "Sign Up"}
                            </Button>
                            <div className={classes.links}>
                                <Link to="/staff/signin" className={classes.linkText}>
                                    Already have an account? Sign In
                                </Link>
                            </div>
                        </form>
                    ) : (
                        <div className="text-center">
                            <Typography variant="body1" style={{ color: "green", marginBottom: 20 }}>
                                {message}
                            </Typography>
                            <Link to="/staff/signin" className={classes.linkText}>
                                Proceed to Login
                            </Link>
                        </div>
                    )}
                </CardContent>
            </Card>
            <Notification notify={notify} setNotify={setNotify} />
        </div>
    );
};

export default withRouter(SignupComponent);
